module.exports = __webpack_public_path__ + "static/media/silkycloud-silver-3.fe5cd7e3.png";